export default __webpack_public_path__ + "static/media/rhb-logo-no-bg.2d3af941.png";